import { useQuery } from "@tanstack/react-query";
import { listSetBanners } from "@api/banners";
import { QUERY_KEYS } from "@common/queryKeys";

// 배너 데이터를 가져오는 함수 (queryFn으로 사용)
const fetchBanners = async () => {
  const res = await listSetBanners({ modes: "ListSet" });

  if (res.Code === "0000") {
    return res?.Data?.rows ?? {}; // 데이터가 없을 경우 빈 객체 반환
  }
  throw new Error(res.Data?.Msg || "데이터 조회 실패");
};

// 배너 목록을 가져오는 커스텀 훅
export const useBannerQuery = () => {
  const { data, refetch, isFetching, isError, error } = useQuery({
    queryKey: QUERY_KEYS.SETTING.BANNERS.ListSet,
    queryFn: fetchBanners,
    suspense: false, // Suspense 모드 비활성화 (hydration 문제 방지)
    // 데이터 선택 및 변환
    select: (rawData) => {
      if (!rawData)
        return {
          bannerList: {},
          headerMenu: [],
          mainAward: [],
          mainStripe: [],
          mainImageStripe: [],
          customSm: [],
          customLg: [],
          interview: [],
          mainBtmM: [],
          mainBtmS: [],
          mainBtmThirdCenter: [],
          mainBtmThirdLeft: [],
          mainBtmThirdRight: [],
          mainEventStripe: [],
          mainSide: [],
          mainTop: [],
          mainTopCenterEvent: [],
          mainTopEvent: [],
          mobileBtm: [],
          prodLeftBtm: [],
          pageOut: [],
        };

      // 데이터 구조화 및 변환
      return {
        bannerList: rawData,
        headerMenu: rawData.header_menu || [],
        lnbEsg: rawData.lnb_esg || [],
        lnbCsboard: rawData.lnb_csboard || [],
        lnbSmallPrint: rawData.lnb_smallPrint || [],
        mainAward: rawData.main_award || [],
        mainStripe: rawData.main_stripe || [],
        mainImageStripe: rawData.main_image_stripe || [],
        customSm: rawData.custom_sm || [],
        customLg: rawData.custom_lg || [],
        interview: rawData.interview || [],
        mainBtmM: rawData.main_btm_m || [],
        mainBtmS: rawData.main_btm_s || [],

        mainBtmFirstRowLeft: rawData.main_btm_first_row_left || [],
        mainBtmFirstRowCenter: rawData.main_btm_first_row_center || [],
        mainBtmFirstRowRight: rawData.main_btm_first_row_right || [],
        mainBtmSecondRowLeft: rawData.main_btm_second_row_left || [],
        mainBtmSecondRowCenter: rawData.main_btm_second_row_center || [],
        mainBtmSecondRowRight: rawData.main_btm_second_row_right || [],
        mainBtmThirdRowLeft: rawData.main_btm_third_row_left || [],
        mainBtmThirdRowCenter: rawData.main_btm_third_row_center || [],
        mainBtmThirdRowRight: rawData.main_btm_third_row_right || [],

        mainBtmThirdCenter: rawData.main_btm_third_center || [], //구버전
        mainBtmThirdLeft: rawData.main_btm_third_left || [], //구버전
        mainBtmThirdRight: rawData.main_btm_third_right || [], //구버전
        mainEventStripe: rawData.main_event_stripe || [],
        mainSide: rawData.main_side || [],
        mainTop: rawData.main_top || [],
        mainTopCenterEvent: rawData.main_top_center_event || [],
        mainTopEvent: rawData.main_top_event || [],
        mobileBtm: rawData.mobile_btm || [],
        prodLeftBtm: rawData.prod_left_btm || [],
        pageOut: rawData.page_out || [],
      };
    },
  });

  // 데이터와 함수 반환
  return {
    ...data, // select에서 처리된 데이터
    isFetching,
    isError,
    error,
    refetch,
  };
};
